import PropTypes from 'prop-types'
import {HTTPNotFound} from 'pwa-kit-react-sdk/ssr/universal/errors'
import React, {useEffect} from 'react'
import {useCommerceAPI} from '../../commerce-api/contexts'
import useAsync from '../../commerce-api/hooks/useAsync'
import RecommendedAccessories from '../../components/recommended-accessories'

/**
 * Displays accessories recommendations for a product
 *
 * @param {string} pid - Product ID
 *
 * @example
 *   <pwa-widget-accessories pid="101001">
 *     $include(...)$
 *   </pwa-widget-product>
 */
const WidgetAccessories = ({pid}) => {
    const api = useCommerceAPI()
    const {error, data, execute} = useAsync(async (id) => {
        const product = await api.shopperProducts.getProduct({
            parameters: {id, select: '(recommendations.(**),c_product-type)'}
        })
        // Copied from ProductDetail.getProps
        // The `commerce-isomorphic-sdk` package does not throw errors, so
        // we have to check the returned object type to inconsistencies.
        if (typeof product?.type === 'string') {
            throw new HTTPNotFound(product.detail)
        }
        return product
    })

    useEffect(() => {
        if (pid) {
            execute(pid)
        }
    }, [execute, pid])

    // should fail silently without an alert
    if (!pid || error) {
        return null
    }

    // prevent initial flash of undefined product
    if (!data) {
        return null
    }

    return <RecommendedAccessories products={[data]} showTitle={false} variant="widget" />
}

WidgetAccessories.propTypes = {
    pid: PropTypes.string
}

export default WidgetAccessories
